/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Creation_TitleInputs */

const en_a11y_statement_creation_title = /** @type {(inputs: A11y_Statement_Creation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creation of this Statement`)
};

const de_a11y_statement_creation_title = /** @type {(inputs: A11y_Statement_Creation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellung dieser Erklärung`)
};

const fr_a11y_statement_creation_title = /** @type {(inputs: A11y_Statement_Creation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creation de cette declaration`)
};

const es_a11y_statement_creation_title = /** @type {(inputs: A11y_Statement_Creation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creacion de esta declaracion`)
};

const it_a11y_statement_creation_title = /** @type {(inputs: A11y_Statement_Creation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creazione di questa dichiarazione`)
};

const nl_a11y_statement_creation_title = /** @type {(inputs: A11y_Statement_Creation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opstellen van deze verklaring`)
};

const pl_a11y_statement_creation_title = /** @type {(inputs: A11y_Statement_Creation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sporzadzenie niniejszego oswiadczenia`)
};

const fi_a11y_statement_creation_title = /** @type {(inputs: A11y_Statement_Creation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tämän lausunnon laatiminen`)
};

const da_a11y_statement_creation_title = /** @type {(inputs: A11y_Statement_Creation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oprettelse af denne erklaering`)
};

const sv_a11y_statement_creation_title = /** @type {(inputs: A11y_Statement_Creation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapande av denna forklaring`)
};

/**
* | output |
* | --- |
* | "Creation of this Statement" |
*
* @param {A11y_Statement_Creation_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_creation_title = /** @type {((inputs?: A11y_Statement_Creation_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Creation_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_creation_title(inputs)
	if (locale === "fr") return fr_a11y_statement_creation_title(inputs)
	if (locale === "es") return es_a11y_statement_creation_title(inputs)
	if (locale === "it") return it_a11y_statement_creation_title(inputs)
	if (locale === "nl") return nl_a11y_statement_creation_title(inputs)
	if (locale === "pl") return pl_a11y_statement_creation_title(inputs)
	if (locale === "fi") return fi_a11y_statement_creation_title(inputs)
	if (locale === "da") return da_a11y_statement_creation_title(inputs)
	if (locale === "sv") return sv_a11y_statement_creation_title(inputs)
	return en_a11y_statement_creation_title(inputs)
});